import { IS_GTM_ENABLED } from 'ssr/components/GoogleTagManager';

type DataLayerRecord = Record<string, unknown>;

type DataLayerArray = DataLayerRecord[];

function getDataLayer(): DataLayerArray {
    if (typeof window === 'undefined') {
        return [];
    }

    window.dataLayer = window.dataLayer || [];
    return window.dataLayer as DataLayerArray;
}

/** When true, in-code platform tracking is skipped and GTM handles tags via dataLayer. */
export const DEFER_CONVERSIONS_TO_GTM =
    process.env.GATSBY_DEFER_CONVERSIONS_TO_GTM === 'true';

/**
 * GTM container is on the page and conversions are deferred to it (not direct code fires).
 * Requires both GATSBY_GOOGLE_TAG_MANAGER_ID and GATSBY_DEFER_CONVERSIONS_TO_GTM=true.
 */
export function shouldDeferConversionsToGtm(): boolean {
    return IS_GTM_ENABLED && DEFER_CONVERSIONS_TO_GTM;
}

/**
 * Whether in-code platform tracking may run (gtag, fbq, pixel scripts, etc.).
 * False only when GATSBY_DEFER_CONVERSIONS_TO_GTM=true and GTM is enabled.
 */
export function shouldSendDirectPlatformTracking(): boolean {
    return !shouldDeferConversionsToGtm();
}

export function pushToDataLayer(
    eventName: string,
    params: DataLayerRecord = {},
): void {
    if (typeof window === 'undefined') {
        return;
    }

    getDataLayer().push({
        event: eventName,
        ...params,
    });
}

export const BOOKING_CONVERSION_EVENT = 'booking_conversion';
export const BOOKING_CONVERSION_NEW_CUSTOMER_EVENT =
    'booking_conversion_new_customer';

/** Alias for pixel init scripts in PostBody / GlobalTrackingPixels / Finished */
export const shouldLoadDirectPixel = shouldSendDirectPlatformTracking;
